import { AxiosResponse } from "axios";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  Tooltip,
  Whisper
} from "rsuite";
import { EPInput } from "../../../common/controls";
import { Info } from "../../../common/controls/info";
import {
  PostDesignation,
  UpdateDesignation
} from "../../../common/utils/api";
import { CommonConstants } from "../../../common/utils/CommonConstants";
import { axiosPost, axiosUpdate } from "../../../common/utils/helper";
import Loader from "../../Loader/loader";

interface IDesignation {
  DesignationId?: number;
  DesignationName?: string;
  CreatedBy?: number;
}
interface Props {
  open: boolean;
  action?: string;
  isValidate?: boolean;
  refresher?: boolean;
  setRefresher?: any;
  singleData?: any;
  setOpen: (open: boolean) => void;
}

export default function AddDesignationModal(props: Props) {
  const { open, setOpen, action, setRefresher, singleData, refresher } = props;

  const [designationModalData, setDesignationModalData] = useState<any>({
    DesignationId: singleData?.DesignationId,
    DesignationName: singleData?.DesignationName,
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [isValidate, setIsValidate] = useState(false);
  const regexPattern = /^(?!.*\s{2})(?!.*-{2})(?!.*\.{2})[a-zA-Z0-9\s.\-(){}\[\]]+$/;

  let response: AxiosResponse;
  function closeModal() {
    setOpen(false);
  }
  function handleKeyPress(event: any) {
    if (
      (event?.target?.value?.endsWith(" ") &&
        !regexPattern.test(event?.target?.value + event?.key)) ||
      !regexPattern.test(event?.target?.value + event?.key)
    ) {
      event.preventDefault();
    }
  }

  function handleModalKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.key === "Enter" && !loading) {
      handleSubmit();
    }
  }

  const handleOnChange = (value: string | number | Date, name: string) => {
    let data = { ...designationModalData };
    data[name] = value;
    setDesignationModalData(data);
  };

  async function handleSubmit() {
    setIsValidate(true);
    if (
      !designationModalData?.DesignationName
    ) {
      const message = "Field cannot be empty.";
      toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (
      designationModalData?.DesignationName?.trim().length < 2
    ) {
      const message = "Please fill mandatory fields.";
      toast.error(message, {
        position: toast.POSITION.TOP_CENTER,
      });
    } 
    else {
      action === "Add"
        ? await postDesignationName(PostDesignation, {
            DesignationName: designationModalData?.DesignationName?.trim(),
          })
        : await updateDesignationName(
            `${UpdateDesignation}/${designationModalData?.DesignationId}`,
            {
                DesignationName: designationModalData?.DesignationName?.trim(),
            }
          );
      refresher ? setRefresher(false) : setRefresher(true);
      closeModal();
    }
  }

  async function postDesignationName(reqUrl: string, reqBody: IDesignation) {
    setLoading(true);
    response = (await axiosPost(reqUrl, { reqBody })) as AxiosResponse;
    if (
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "success"
    ) {
      setLoading(false);
      toast.success("Designation saved successfully.", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (
      response.status == CommonConstants.API_RESPONSE_CONFLICTS_IN_REQUEST &&
      response.data?.status === "error"
    ) {
      setLoading(false);
      toast.warning("Designation already exists.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
  async function updateDesignationName(reqUrl: string, reqBody: IDesignation) {
    response = (await axiosUpdate(reqUrl, { reqBody })) as AxiosResponse;
    if (
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "success"
    ) {
      toast.success("Designation updated successfully.", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (
      response.status == CommonConstants.API_RESPONSE_CONFLICTS_IN_REQUEST &&
      response.data?.status === "error"
    ) {
      toast.warning("Designation already exists.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  return loading ? (
    <Loader />
  ) : (
    <Modal open={open} onClose={closeModal} className="modal-sm" backdrop="static" keyboard={false} onKeyDown={handleModalKeyDown}>
      <Modal.Header closeButton={true}>
        {action === "Edit" ? "Edit Designation" : "Add Designation"}
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col xs lg="12" className="recruiter-label">
            Designation Name <span className="req">* </span>
            <Info message="Minimum 2 characters, Maximum 100 characters" />
          </Col>
          <Col xs lg="12" className="recruiter-label">
              <Whisper trigger="focus" speaker={<Tooltip>Required</Tooltip>}>
                <EPInput
                  onKeyPress={handleKeyPress}
                  label="Designation"
                  minlength={2}
                  maxlength={100}
                  style={{ width: 100 }}
                  onChange={(val: string) => handleOnChange(val, "DesignationName")}
                  value={designationModalData?.DesignationName}
                  isValidate={isValidate}
                />
              </Whisper>
            </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="pt-3">
        <Row>
          <Col xs lg>
            <Button
              type="button"
              onClick={() => handleSubmit()}
              className="btn btn-primary"
            >
              {action === "Edit" ? "Update" : "Save"}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}
